import { composeMapper } from '@wix/editor-elements-preview-utils';
import { createComponentPreviewMapperModel, withCompPreviewInfo, } from '@wix/editor-elements-integrations';
import { props as viewerPropsMapper } from './MediaContainer.mapper';
const setBackgroundMediaProps = (fillLayers) => {
    if (fillLayers.backgroundMedia) {
        const image = fillLayers.image || fillLayers.video?.posterImageInfo;
        const width = image?.containerWidth;
        const height = image?.containerHeight;
        fillLayers.backgroundMedia.containerSize = {
            width,
            height,
        };
    }
};
const setVideoPlaybackProps = (fillLayers, isPlayingAllowed) => {
    if (fillLayers.video) {
        fillLayers.video.videoInfo.autoPlay =
            fillLayers.video.videoInfo.autoPlay && isPlayingAllowed;
    }
};
export const getFillLayersPreviewProps = (carmiData, { isPlayingAllowed, componentViewMode, }) => {
    let { fillLayers } = carmiData;
    if (!fillLayers.video && !fillLayers.backgroundMedia) {
        return carmiData;
    }
    fillLayers = JSON.parse(JSON.stringify(fillLayers));
    setBackgroundMediaProps(fillLayers);
    setVideoPlaybackProps(fillLayers, isPlayingAllowed);
    if (fillLayers.video) {
        fillLayers.video.videoInfo.isEditorMode = componentViewMode === 'editor';
    }
    return {
        ...carmiData,
        fillLayers,
        ...(fillLayers.video
            ? {
                previewWrapperProps: {
                    autoPlayVideo: fillLayers.video?.videoInfo.autoPlay,
                    isPlayingAllowed,
                },
            }
            : {}),
    };
};
export const props = composeMapper()(viewerPropsMapper, { add: ['isPlayingAllowed', 'compDesign', 'componentViewMode'] }, (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { isPlayingAllowed, compDesign, componentViewMode } = deps;
    const borderWidth = compDesign?.cssStyle?.cssBorder.width;
    const fillLayersPreviewProps = getFillLayersPreviewProps(carmiData, {
        isPlayingAllowed,
        componentViewMode,
    });
    const previewWrapperProps = fillLayersPreviewProps.previewWrapperProps || {};
    return {
        ...viewerProps,
        ...fillLayersPreviewProps,
        previewWrapperProps: {
            ...previewWrapperProps,
            borderWidth,
        },
    };
});
export const css = withCompPreviewInfo()(['renderFixedPositionBackgrounds'], (deps, carmiData) => {
    const position = carmiData['--fill-layer-background-media-position'];
    if (position) {
        const isFixed = position === 'fixed' && deps.renderFixedPositionBackgrounds;
        return {
            ...carmiData,
            '--fill-layer-background-media-position': isFixed ? 'fixed' : 'absolute',
        };
    }
    return carmiData;
});
export default createComponentPreviewMapperModel({ props, css });
//# sourceMappingURL=MediaContainer.previewMapper.js.map